<template>
<div class="menuBody" >
       <!-- <RoomTree @RoomManTree="getMsgFormSon" /> -->
        <CompanyBindingDialog  ref="CompanyBindingDialog" />
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card" style="margin-left:35px">
        <el-row :gutter="10">
            <div class="PageTabs">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="待绑定" name="first">待绑定</el-tab-pane>
                <el-tab-pane label="已通过" name="second">已通过</el-tab-pane>
                <el-tab-pane label="已拒绝" name="third">已拒绝</el-tab-pane>
              </el-tabs>
            </div>
            <div style="width:150px;float:left;margin-left:30px">
                 <el-input placeholder="请输入用户名称" size="small"  v-model="userName"></el-input>
            </div>
             <div style="width:150px;float:left;margin-left:30px">
                 <el-input placeholder="请输入用户手机号" size="small"  v-model="userTel"></el-input>
            </div>
             <div style="width:220px;float:left;margin-left:30px">
                   <el-date-picker
                      size="small"
                      style="width:220px;float:left;"
                      v-model="TimeQuantum"
                      type="daterange"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="BillDateTime()">
                    </el-date-picker>
              </div> 
            <div style="float:left;margin-left:30px">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" @click="Inquire()">查询</el-button>
            </div>
    <el-table tooltip-effect="light"   :data="tableData" v-loading="loading"  style="overflow-y: scroll;float:right;margin-top:30px;" row-key="id" border  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column show-overflow-tooltip prop="userName" label="用户名"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="applyName" label="申请人" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="roomName" label="房间名" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="address"  label="认证房间地址" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="cusName" label="预留业主信息" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="applyCusName" label="填写业主信息" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="idName" label="认证类型" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="auditRes" label="状态" >
       <template slot-scope="scope">
        <el-tag type="success" v-if="scope.row.auditRes=='0'" >未审核</el-tag>
        <el-tag v-if="scope.row.auditRes=='1'" >通过</el-tag>
        <el-tag type="warning" v-if="scope.row.auditRes=='-1'" >拒绝</el-tag>
      </template>
    </el-table-column>
    <el-table-column show-overflow-tooltip prop="auditName" label="审核人" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="auditDate" label="审核日期" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="createDate" label="提交日期" ></el-table-column>
    <el-table-column fixed="right" label="操作"  >
     <template slot-scope="scope">
          <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small" title="查看详情"></el-button>
        </template>
    </el-table-column>
  </el-table>     
        <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination>     
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import CompanyBindingDialog from "./RoomBinding/CompanyBindingDialog";
import RoomTree from "../common/RoomManTree.vue";

export default {
  name: "RoomRefuseBinding",
  components: {CompanyBindingDialog,RoomTree},
  data() {
    return {
  activeName: 'third',
      total:0,
      loading:false,
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面

      diaLogVisible: false,

      userTel:"",
      roomName:"",
      userName:"",
      TimeQuantum:[],
      tableData:[],

    }
  },
     watch: {
    //   // 监听路由变化
     "$route.path": function(newVal, oldVal) {
       if(`${newVal}` == "/wy/CorporateEstate/index"){
       this.activeName = "first"
       }else if(`${newVal}` == "/wy/CorporateEstateNew/index"){
        this.activeName = "second"
       }else if(`${newVal}` == "/wy/CorporateEstateRefuse/index"){
        this.activeName = "third"
       }
     }
  },
  methods: {
    BillDateTime(time){
      var d = this.DateTime[0]
      var datetime=d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
      var done = this.DateTime[1]
      var datetimeone=done.getFullYear() + '-' + (done.getMonth() + 1) + '-' + done.getDate();
      this.fromDate = datetime
      this.toDate = datetimeone
    },
          handleClick(tab, event) {
        if(this.activeName == "first"){
          this.activeName = "first"
          this.$router.push({name: 'CompanyRoomStayBinding'})
        }else if(this.activeName == "second"){
          this.activeName = "second"
          this.$router.push({name: 'CompanyRoomWinBinding'})
        }else if(this.activeName == "third"){
          this.activeName = "third"
          this.$router.push({name: 'CompanyRoomRefuseBinding'})
        }
      },
    getMsgFormSon(data){
       if(data.orgId !=null){
        this.projectId = data.orgId
      }else{
        this.loading = true
        this.floorId = data.id
        this.projectId = data.projectIdT
          this.getAllMenu()
      }
      this.AllData = data
    },
     handleSizeChange(val) {
       this.loading = true
        this.pagesize  = val
        this.getAllMenu()
    },
    handleCurrentChange(val) {
      this.loading = true
        this.currentPage = val
        this.getAllMenu()
    },
    Inquire(){
      this.loading = true
      let DataTime = this.DateTime
      let Regular = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      let userTel = this.userTel
      if(userTel.length !=0){
        if(!Regular.test(userTel)){
          this.$message({
            message: '请输入正确手机号',
            type: 'warning'
          });
        }else{
          if(DataTime != undefined) {
          let obj = {
            "userName":this.userName,
            "applyTel":userTel,
            "page":this.currentPage, // 当前页
            "size":this.pagesize,  // 每页大小
            "isEnterprise":"1",
            "auditRes": "-1",
            "fromDate":this.fromDate,
            "toDate":this.toDate,
          }
        this.$http.post(this.$requestUrl.POST_COMPANY_LIST,obj).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.loading = false
            this.total = data.data.total
            for(let val of data.data.records){
              val.NameTel = val.applyName +" -- "+ val.applyTel
              val.CusNameTel = val.applyCusName +" -- "+ val.applyCusTel
            }
            this.tableData = data.data.records;
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
          
          }
        }
      }else{
          let obj = {
            "userName":this.userName,
            "applyTel":userTel,
            "page":this.currentPage, // 当前页
            "size":this.pagesize,  // 每页大小
            "isEnterprise":"1",
            "auditRes": "-1",
            "fromDate":this.fromDate,
            "toDate":this.toDate,
          }
         this.$http.post(this.$requestUrl.POST_COMPANY_LIST,obj).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.loading = false
            this.total = data.data.total
            for(let val of data.data.records){
              val.NameTel = val.applyName +" -- "+ val.applyTel
              val.CusNameTel = val.applyCusName +" -- "+ val.applyCusTel
            }
            this.tableData = data.data.records;
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
      }
    },
    getAllMenu() {
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "isEnterprise":"1",
        "auditRes": "-1",
        }
        this.$http.post(this.$requestUrl.POST_COMPANY_LIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.total = data.data.total
            this.tableData = data.data.records
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
      },
    editMenu(row) { // 修改
      this.$refs.CompanyBindingDialog.auditComment = row.auditComment
      this.$refs.CompanyBindingDialog.title = "查看";
      this.$refs.CompanyBindingDialog.dialogVisible = true; 
      this.$refs.CompanyBindingDialog.formLabelAlign = row
        },
  },
  mounted() {
    this.getAllMenu()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    //  margin-left: 35px;
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }

}
.PageTabs{
  width: 100%;
  margin-bottom: 20px;
  .el-tabs__nav-scroll{
    border:none
  }
}
.el-tabs__content{
  display: none;
}
.el-tabs__item.is-active{
  background: #fff;
}
</style>